/**
 * `useReducedMotion` — tracks `prefers-reduced-motion` and re-renders
 * when the user's preference changes mid-session.
 *
 * Framer Motion has its own hook by the same name; we duplicate it
 * here so non-motion code (e.g. the Spark moment's fallback static
 * card) can also branch on the preference without pulling Framer.
 */

import { useEffect, useState } from 'react';

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduced;
}
